
<template>
<div>

    <div ref="paypal" ></div>

</div>
</template>
<script>

export default {
  name: 'paypal',

  components: {
  },
  props:{
    initiative_id: String,
    product: Object,
    amount: Object
  },
   data () {
        return {

             loaded: false,
                  paidFor: false,



        }
      },

      created: function() {


const script = document.createElement("script");
          script.src =
            "https://www.paypal.com/sdk/js?client-id=AecaRLz0PhiVFEu4BPSlkgCRCMCCm5-gyiqFoLJ2AMG4s08gKZ_i2UbnKCRWDSmhjPkEpaKkfBlqu3KG&currency=USD";
          script.addEventListener("load", this.setLoaded);
          const script1 = document.createElement("script");
  
          script1.src =
            "https://www.paypal.com/sdk/js?client-id=AV64lwTRpx4_o0hQWT_C4Q6E8ZKXuRK1ImomqPeju0MIE8_gFGtuopIGTXvpm1MDshbYsQRvZt4WIAAi&currency=USD";
            script1.addEventListener("load", this.setLoaded);
          document.body.appendChild(script1);
        },
        methods: {
            setLoaded: function() {
              this.loaded = true;

              window.paypal
                .Buttons({


                  createOrder: (data, actions) => {
                 // this.$bvModal.show('modal-1"')
                    return actions.order.create({
                      purchase_units: [
                        {
                          description: this.product.description,
                          amount: {
                            currency_code: "USD",
                            value: this.product.price
                          }
                        }
                      ]
                    });
                  },

                  onApprove: async (data, actions) => {
                    const order = await actions.order.capture();
                    console.log(order)
                    console.log(this.initiative_id)
                  
                    this.paidFor = true;
                         this.$store.dispatch('ledger_auth/closeCandidateDonationModal')
                         this.$store.dispatch('donations/setDonationCampaignInitiative',{order:order, campaign_id: '4644c74b-8afc-4a9a-b355-e89d7c06914b', initiative_id: this.initiative_id, })
                        
                  },
                  onError: err => {
                    console.log(err);
                  }
                })
                .render(this.$refs.paypal);
            }
          }

}

</script>
